export default "__VITE_ASSET__d83d0bf7__"